import React, { useEffect } from 'react'
import { useMsal } from "@azure/msal-react";
import { msalConfigLogin } from "./authConfig";

import auth from '../Helpers/auth'

import set from '../assets/icons/sign_off.svg';

const SignOutButton = () => {
    const { instance } = useMsal();

    const handleOutLogin = (instance) => {
        instance.logoutPopup(msalConfigLogin).then((response)=>{
            auth.signOut()
            setTimeout(()=>{
                window.location.href="./"
            },500)
        });
    }   
    
    useEffect(()=>{

    },[])

    return (
        <div className="cerrar"> 
            <button className="section-cerrar" onClick={() => handleOutLogin(instance)} > 
                <img className="fotoC" src={set} alt="" /> 
                <span className="text"> CERRAR SESIÓN </span>
            </button>
        </div>
       /*  <button onClick={() => handleOutLogin(instance)}>Cerrar sesion.</button> */
    );
}

export default SignOutButton;